import { defineStore } from 'pinia';

export const useTemplatesMenuStore = defineStore('templatesMenu', {
  state: () => ({
    agGridApi: null,
    agGridColumnApi: null,
  }),

  actions: {
    setAgGridApi(api) {
      this.agGridApi = api;
    },
    setAgGridColumnApi(api) {
      this.agGridColumnApi = api;
    },
  },
});
